import styled from "styled-components";

export const TOFlowWrapper = styled.div<{isDesktop: boolean}>`
    max-width: 545px;
    //background: #060708;
    position: relative;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    overflow: ${({isDesktop}) => isDesktop ? 'visible' : 'hidden'};
`
export const TOFlowContainer = styled.div<{$isTgView: boolean}>`
    height: 100vh;
    padding-top: ${({$isTgView}) => $isTgView ?'10%' : undefined};
    //padding-top: 10%;
    max-width: 543px;
    //background: #060708;
    position: relative;
    display: flex;
    overflow: hidden;
    flex-direction: column;
    box-sizing: border-box;
    @media (max-height: 940px) {
        
        //width: 300px;
        //background: teal;
        max-width: 390px;
    }
`
export const TOFSetting = styled.div<{ isOpen: boolean, isDesktopTgApp: boolean}>`
    //background: #27292E;
    //height: 89px;
    //width: 100%;
    //width: 473px;
    max-width: 545px;
    //width: 390px;
    height: 90px;
    //height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: ${({isOpen}) => isOpen ? '11px 11px 0 0 ' : '11px'};
    //border: 1px solid #27292E;
    //margin: 37px 20px;
    position: relative;
    box-sizing: border-box;
    & > div {
        display: flex;
        align-items: center;
        width: 100px;
        height: 100%;
        justify-content: center;
    }
  
    & > div:nth-child(2) {
        padding-left: 20px;
    }
    //& > div:nth-child(3) {
    //    width: 30%;
    //    padding-right: 10px;
    //}
    @media (max-height: 940px) {
        max-width: 390px;
        //max-height: 90px;
        // padding: ${({isDesktopTgApp}) =>  isDesktopTgApp ? '10px 25px 10px 155px' : '0 25px 15px 155px'} ;
    }
    // @media (max-height: 900px) {
    //     max-width: 390px;
    //     max-height: 90px;
    //     padding: ${({isDesktopTgApp}) =>  isDesktopTgApp ? '10px 15px 10px 15px' : '30px 15px 15px 15px'} ;
    // }
    // @media (max-height: 890px) {
    //     max-width: 360px;
    //     max-height: 90px;
    //     padding: ${({isDesktopTgApp}) =>  isDesktopTgApp ? '10px 15px 10px 15px' : '45px 15px 15px 15px'} ;
    // } 
    // @media (max-height: 890px) {
    //     max-width: 390px;
    //     //max-width: 100%;
    //     max-height: 90px;
    //      padding: ${({isDesktopTgApp}) =>  isDesktopTgApp ? '10px 20px 10px 20px' : '35px 15px 15px 15px'} ;
    // }
`

export const TOFMainContainer = styled.div<{ isOpen: boolean, isDesktopTgApp: boolean}>`
    width: 473px;
    height: calc(100vh - 90px - 100px);
    min-height: 400px;
    z-index: 2;
    box-sizing: border-box;
    padding: 0 25px;
    //position: relative;
    @media (max-height: 940px) {
        width: 390px;
        height: calc(100vh - 90px - 100px);
        min-height: 600px;
    }
    @media (max-height: 850px) {
        width: 390px;
        height: calc(100vh - 90px - 100px);
        min-height: 400px;
    }
    // @media (max-height: 900px) {
    //     width: 390px;
    //     height: calc(100% - 90px - 100px);
    //     //min-height: calc(100% - 90px - 100px);
    //     min-height: ${({isDesktopTgApp}) => isDesktopTgApp ? 'calc(100% - 90px - 100px)' : 'calc(100% - 90px - 100px - 70px)'};
    // }
    // @media (max-height: 850px) {
    //     width: 390px;
    //     height: calc(100% - 90px - 100px);
    //     //min-height: calc(100% - 90px - 100px);
    //     min-height: ${({isDesktopTgApp}) => isDesktopTgApp ? 'calc(100% - 90px - 100px)' : 'calc(100% - 90px - 100px - 70px)'};
    // }
    // @media (max-height: 800px) {
    //     width: 390px;
    //     height: calc(100% - 90px - 100px);
    //     //min-height: calc(100% - 90px - 100px);
    //     min-height: ${({isDesktopTgApp}) => isDesktopTgApp ? 'calc(100% - 90px - 100px)' : 'calc(100% - 90px - 100px - 70px)'};
    // }
`
export const InfoButton = styled.div<{ isOpen: boolean, isMobile: boolean}>`
    width: 54px;
    height: 36px;
    font-size: 13px;
    border-radius: 4px;
    //border: 1px solid #595D69;
    // color: ${({isOpen}) => isOpen ? undefined : '#595D69'};
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    cursor: pointer;
    margin-top: ${({isMobile}) => isMobile ? '50px' : 'none'};
    // background: ${({isOpen}) => isOpen ? '#595D69' : undefined};
    box-sizing: border-box;
    & > svg {
        width: 24px;
        height: 24px;
        stroke: ${({isOpen}) => !isOpen ? '#595D69' : '#23AF91'};
    }
    //&:hover {
    //    & > svg {
    //        stroke: white;
    //    }
    //}
`
export const MenuButton = styled(InfoButton)<{ isOpen: boolean, isMobile: boolean}>`
    position: relative;
`

export const FavoriteButton = styled.div<{ isOpen: boolean }>`
    width: 98px;
    height: 26px;
    font-size: 13px;
    border-radius: 4px;
    border: 1px solid #595D69;
    color: ${({isOpen}) => isOpen ? undefined : '#595D69'};
    text-align: center;
    align-content: center;
    cursor: pointer;
    background: ${({isOpen}) => isOpen ? '#595D69' : undefined}
`

export const SettingsButton = styled.div<{isOpen: boolean}>`
    width: 123px;
    height: 26px;
    font-size: 13px;
    text-align: center;
    //align-content: center;
    background: ${({isOpen}) => isOpen ? '#7492FE' : 'inherit'};
    color: ${({isOpen}) => isOpen ? 'black' : '#7492FE'};
    border: 1px solid #7492FE;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    //display: flex;
    & > svg {
        stroke: ${({isOpen}) => isOpen ? 'black' : '#7492FE'};
        fill: ${({isOpen}) => isOpen ? 'black' : '#7492FE'};
        width: 12px;
        height: 12px;
        margin-right: 5px;
        margin-top: 4px;
    }
`

export const Footer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    //position: sticky;
    padding: 0 20px;
    height: 120px;
    max-width: 390px;
    width: 100%;
    box-sizing: border-box;
    @media (max-height: 940px) {
        height: 140px;
    } 
    @media (max-height: 800px) {
        height: 120px;
    }
`
export const SettingsBottomButton = styled.div<{isOpen: boolean}>`
    border: 1px solid ${({isOpen}) => isOpen ? '#23AF91' : 'rgba(255,255,255,0.1)'};
    background: rgba(255,255,255,0.05);
    width: 64px;
    z-index: 1;
    height: 56px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-sizing: border-box;
    & > svg{
        // fill: ${({isOpen}) => isOpen ? '#23AF91' : 'rgba(255,255,255,0.05)'};
        stroke: ${({isOpen}) => isOpen ? '#23AF91' : '#929AA5'};
        height: 20px;
        width: 20px;
    }
    transition: transform 0.15s ease;
    &:active {
        transform: scale(0.95);
        //opacity: 0.9;
    }
`
export const FavoritesBottomButton = styled.div<{ isOpen: boolean }>`
    display: flex;
    border: 1px solid ${({isOpen}) => isOpen ? '#23AF91' : 'rgba(255,255,255,0.1)'};
    background: rgba(255,255,255,0.05);
    width: 64px;
    z-index: 1;
    height: 56px;
    border-radius: 14px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-sizing: border-box;
    & > svg{
        fill: ${({isOpen}) => isOpen ? '#23AF91' : 'rgba(255,255,255,0.05)'};
        stroke: ${({isOpen}) => isOpen ? '#23AF91' : '#929AA5'};
        height: 20px;
        width: 20px;
    }
    transition: transform 0.05s ease;
    &:active {
        transform: scale(0.95);
        //opacity: 0.9;
    }
`

export const PlayPauseButton = styled.div<{ isStopped?: boolean }>`
    width: 128px;
    height: 56px;
    border: 1px solid ${({isStopped}) => isStopped ? '#23AF91' : '#ffffff10'} ;
    background: rgba(255,255,255,0.05);
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    cursor: pointer;
    box-sizing: border-box;
    & > svg {
        height: 20px;
        width: 20px;
        stroke: ${({isStopped}) => isStopped ? '#23AF91' : '#929AA5'} ;
    }
    transition: transform 0.15s ease;
    &:active {
        transform: scale(0.95);
        //opacity: 0.9;
    }
`
export const BottomRightHalo = styled.div`
    //background: #7492FE;
    //background: #23AF91;
    //position: fixed;
    pointer-events: none;
    background: radial-gradient(
            //ellipse at right top,
            circle,
            rgba(35, 175, 145, 0.45) 0%,
            rgba(35, 175, 145, 0.12) 60%,
            rgba(35, 175, 145, 0.05) 85%,
            rgba(0, 0, 0, 0) 100%
    );
    filter: blur(100px);
    bottom: 28%;
    //bottom: 50%;
    height: 760px;
    width: 480px;
    position: absolute;
    opacity: 0.8;
    //transform: scale(1.2);
    //z-index: 1;
    //border: 1px solid rgba(0, 0, 0, 0);
    //border-radius: 50%;
    //transform: translate(8%, 120%);
    //transform: translate(5%, 150%);
    //@media(max-height: 940px) {
    //    filter: blur(90px);
    //    height: 500px;
    //    width: 600px;
    //    border-radius: 50%;
    //    transform: translate(5%, 172%);
    //}
    //@media(max-height: 900px) {
    //    filter: blur(90px);
    //    height: 500px;
    //    width: 600px;
    //    border-radius: 50%;
    //    transform: translate(5%, 162%);
    //}
    //@media(max-height: 850px) {
    //    filter: blur(90px);
    //    height: 500px;
    //    width: 600px;
    //    border-radius: 50%;
    //    transform: translate(5%, 146%);
    //}
    //@media(max-height: 800px) {
    //    filter: blur(90px);
    //    height: 500px;
    //    width: 600px;
    //    border-radius: 50%;
    //    transform: translate(5%, 120%);
    //}
`
export const Wrapper = styled.div<{isWeb: boolean}>`
    display: flex;
    background: #060708;
    justify-content: center;
    box-sizing: border-box;
    overflow: hidden;
`